import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-shared-page-header',
  templateUrl: './shared-page-header.component.html',
  styleUrls: ['./shared-page-header.component.scss'],
  standalone: false,
})
export class SharedPageHeaderComponent {
  @Input() title: string;
  @Input() subTitle = '';
  @Input() subTitleBold = '';
  @Input() showBadge = false;
  @Input() badgeText = '';
  @Output() readonly badgeClicked: EventEmitter<void> = new EventEmitter<void>();

  onBadgeClicked(): void {
    this.badgeClicked.emit();
  }
}
